import Cookies from 'js-cookie'

const rocketChatConfig = {
  baseApiUrlMobile: {
    sit: 'https://openapi-uat-usa.platanus.com',
    prod: 'https://openapi-usa.platanus.com'
  },
  baseApiUrl: {
    sit: 'https://api-uat-usa.platanus.com',
    prod: 'https://api-usa.platanus.com'
  },
  gaiaApiKey: {
    sit: 'c10aa937-ec9f-4909-b25d-6a7459587593',
    prod: '612cf5b5-a81f-4adc-a616-66d860db1699'
  },
  chatBaseUrl: {
    sit: 'https://rocketchat-uat.platanus.com',
    prod: 'https://im.platanus.com'
  },
  bpmBaseApiUrl: {
    sit: 'https://bpm3-sit-usa.platanus.com/#/process/iframeForm?instanceId',
    prod: 'https://bpm3-usa.platanus.com/#/process/iframeForm?instanceId'
  }
}

function getRocketChatEnv() {
  const host = window.location.host || ''
  const href = window.location.href || ''
  if (
    host.includes('localhost') ||
    host.startsWith('127.0.0.1') ||
    host.includes('sit') ||
    host.includes('dev') ||
    host.includes('uat')
  ) {
    return 'sit'
  }
  if (href.includes('sit') || href.includes('localhost') || href.includes('127.0.0.1')) {
    return 'sit'
  }
  return 'prod'
}

function isPC() {
  if (navigator.userAgent.match(/(pad|ipad)/i)) {
    if (navigator.userAgent.indexOf('com.longfor') > -1 || navigator.userAgent.indexOf('kuaiyixing.CheYiXing') > -1) {
      return false
    }
    return true
  }
  if (navigator.userAgent.match(/(phone|pod|iPhone|iPod|ios|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
    return false
  }
  return true
}

function getDefaultAzureToken() {
  try {
    const p = new URLSearchParams(window.location.search)
    return p.get('token') || Cookies.get('CASTGC') || Cookies.get('account') || ''
  } catch (e) {
    return Cookies.get('CASTGC') || Cookies.get('account') || ''
  }
}

async function getRocketChatUsername(platanusUser, envKey) {
  const q = encodeURIComponent(platanusUser)
  const endpoint = isPC()
    ? `${rocketChatConfig.baseApiUrl[envKey]}/longchatpoc/api/bpm/getRocketChatUser?platanusUser=${q}`
    : `${rocketChatConfig.baseApiUrlMobile[envKey]}/longchatpoc/api/bpm/getRocketChatUser?platanusUser=${q}`
  const res = await fetch(endpoint, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'X-Gaia-Api-Key': rocketChatConfig.gaiaApiKey[envKey]
    }
  })
  if (!res.ok) {
    return null
  }
  const data = await res.json()
  return data.user || null
}

/**
 * 与 sulphur-shuanghu sendRocketChatMessage 一致：发 longchatpoc 消息并在 PC 端打开 Rocket.Chat
 */
export async function sendRocketChatMessage({ url, content, postData, azureToken, vm }) {
  const envKey = getRocketChatEnv()
  const token = azureToken != null ? azureToken : getDefaultAzureToken()

  try {
    const [sender, receiver] = await Promise.all([
      getRocketChatUsername(postData.suser, envKey),
      getRocketChatUsername(postData.rusers[0], envKey)
    ])

    if (!sender || !receiver) {
      vm.$message.error('获取 Rocket.Chat 用户信息失败，请稍后再试')
      return null
    }

    const messagePayload = {
      url: `${rocketChatConfig.bpmBaseApiUrl[envKey]}=${url}&systemId=WUCAP&unifySystemNo=WUCAP`,
      title: content,
      sender,
      receiver,
      azureToken: token
    }

    const endpoint = isPC()
      ? `${rocketChatConfig.baseApiUrl[envKey]}/longchatpoc/api/bpm/sendMsg`
      : `${rocketChatConfig.baseApiUrlMobile[envKey]}/longchatpoc/api/bpm/sendMsg`

    const res = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Gaia-Api-Key': rocketChatConfig.gaiaApiKey[envKey]
      },
      body: JSON.stringify(messagePayload)
    })

    if (res.status === 500 || !res.ok) {
      vm.$message.error('发送失败，请稍后再试')
      return null
    }

    const data = await res.json()
    if (!data.roomId) {
      vm.$message.error('发送失败，请稍后再试')
      return null
    }

    const chatRedirectUrl = `${rocketChatConfig.chatBaseUrl[envKey]}/direct/${data.roomId}`
    if (isPC()) {
      window.open(chatRedirectUrl, '_blank')
    }

    return res
  } catch (error) {
    vm.$message.error('发送失败，请稍后再试')
    console.error('RocketChat message send failed:', error)
    return null
  }
}
